import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { formatPrice } from '../../../../../common/global/helpers';
import { ErrorPanel } from '../../../../../common/widgets/ErrorPanel';
import LoadingSpinner from '../../../../../common/widgets/LoadingSpinner';
import { EmptyStateEmptyHeaderCart } from '../../../Pages/Common/EmptyStates';
import { config } from '../../../config';
import { rewriteImageUrl } from '../../../helpers';
import { CartItem } from '../../../models/Cart';
import { resources } from '../../../resources/resources';

interface ICartDropdownProps {
  cartItems: CartItem[];
  isLoading?: boolean;
  hasError?: boolean;
}

export default function CartDropdown(props: Readonly<ICartDropdownProps>) {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const { cartItems, isLoading, hasError } = props;

  if (isLoading) return <LoadingSpinner size="medium" />;

  if (hasError) return <ErrorPanel />;

  if (cartItems.length == 0) {
    return (
      <div className="empty-cart-msg">
        <EmptyStateEmptyHeaderCart />
      </div>
    );
  }

  return (
    <>
      <div className="cart-content">
        <ul className="cart-list">
          {cartItems.map(ci => (
            <li key={ci.cartItemId}>
              <Link to={`/products/${ci.product.productId}`}>
                <span className="cart-list-img">
                  <img
                    src={rewriteImageUrl(ci.product.imagePath)}
                    alt={ci.product.name}
                  />
                </span>
                <span className="cart-list-name">{ci.product.name}</span>
                <span className="cart-list-value">
                  {formatPrice(
                    (ci.price.discountedPrice ?? ci.price.defaultPrice) *
                      ci.quantity,
                  )}
                  <sup>{`${config.currency}`}</sup>
                </span>
              </Link>
            </li>
          ))}
        </ul>

        <div className="cart-total">
          <span className="cart-total-label">
            {translate(resources.cart.dropdown.total)}
          </span>
          <span className="cart-total-value">
            {formatPrice(
              _.sum(
                _.map(
                  props.cartItems,
                  ci =>
                    ci.quantity *
                    (ci.price.discountedPrice ?? ci.price.defaultPrice),
                ),
              ),
            )}
            <sup>{`${config.currency}`}</sup>
          </span>
        </div>
      </div>
      <button
        onClick={() => navigate('/cart')}
        className="btn btn-outline btn-full"
      >
        <span className="btn-text">
          {translate(resources.cart.dropdown.viewCartPage)}
        </span>
      </button>
    </>
  );
}
